import HTMLTemplate from './template.html'
import PoweredByISOSLogo from '../../resources/images/powered-by-International-SOS.png'
import './styles.scss'
import InternationalSOSAlerts from '../../modules/InternationalSOSAlerts'
import AvsecAlerts from '../../modules/avsecAlerts'
import { AlertsBar } from '../AlertsBar/AlertsBar'
import { EventFilter } from '../EventFilter/EventFilter'
import { sortBy, groupBy, cloneDeep } from 'lodash'
import { EventDetailsPanel } from '../EventDetailsPanel/EventDetailsPanel'
import moment from 'moment'
import MaritimeAlerts from '../../modules/maritimeAlerts'
import User from '../../modules/user'
import { checkIfAlertsAreInAirportRange } from '../../services/EventsService'
import { MyAirports } from '../MyAirports/MyAirports'
import poweredbyRIImage from './../../resources/images/luxury-yachting/poweredbyRI.png'
import tippy, { followCursor } from 'tippy.js'
import { AlertBarBottom } from '../AlertBarBottom/AlertBarBottom'
import { SideNavigation } from '../SideNavigation/SideNavigation'

export const EventPanel = (() => {
    const vueComponent = {
        data() {
            return {
                PoweredByISOS: PoweredByISOSLogo,
                poweredbyRIImage: poweredbyRIImage,
                alerts: [],
                maritimeAlerts: [],
                avsecAlerts: [],
                eventsGroupedByDate: {},
                displayAlerts: true,
                displayMaritimeAlerts: false,
                visibleTotalEvent: 0,
                totalEvent: 0,
                eventsDaysToDisplay: 1,
                includeAviationAlerts: true,
                includeMaritimeAlerts: true,
                userPermission: [],
                activeTab: 'Global',
                watchListAirports: [],
                airportsData: [],
                displayMyAirportTab: true
            }
        },
        mounted() {
            User.getUserPermissions().then(permissions => {
                this.userPermission = permissions

                // Hide My Airport tab if user has medical or comprehensive_crew_support permissions only
                if (((permissions.includes('medical') || permissions.includes('comprehensive_crew_support')) && permissions.indexOf('basic') === -1) || (permissions.includes('luxury_yachting') || permissions.includes('MediTrack'))) {
                    this.displayMyAirportTab = false
                }
            })
        },
        methods: {
            initialize(includeAviationAlerts = true, maritimeAlerts = false) {
                this.includeAviationAlerts = includeAviationAlerts
                this.includeMaritimeAlerts = maritimeAlerts

                if (maritimeAlerts) {
                    this.displayMaritimeAlerts = true
                }

                this.fetchLatestAlerts()

                const ONE_MINUTE = 1000 * 60
                window.setInterval(() => {
                    this.fetchLatestAlerts(true)
                }, ONE_MINUTE)
            },
            fetchLatestAlerts(realTimeObserver) {
                const eventPromises = [
                    InternationalSOSAlerts.getModuleLatestAlerts(),
                    this.includeAviationAlerts ? AvsecAlerts.getModuleLatestAlerts() : Promise.resolve([]),
                    this.includeMaritimeAlerts ? MaritimeAlerts.getModuleLatestAlerts() : Promise.resolve([]),
                ]

                Promise.all(eventPromises).then(values => {
                    const [sosAlerts, avsecAlerts, maritimeAlerts] = values

                    const hasAlerts = sosAlerts.length > 0 || 
                    (this.includeAviationAlerts && avsecAlerts.length > 0) || 
                    (this.includeMaritimeAlerts && maritimeAlerts.length > 0)

                    // No need to proceed and repaint events if there isn't anything new when listening for new events
                    if (!realTimeObserver || (realTimeObserver && hasAlerts)) {
                        this.alerts = sosAlerts || []
                        this.maritimeAlerts = maritimeAlerts || []
                        this.avsecAlerts = avsecAlerts || []
                        this.addEvents()
                        this.getCounts()
                    }
                })
            },
            getCounts() {
                this.visibleTotalEvent = 0
                if (this.displayAlerts) this.visibleTotalEvent = this.visibleTotalEvent + this.alerts.length + this.avsecAlerts.length
                if (this.displayMaritimeAlerts) this.visibleTotalEvent = this.visibleTotalEvent + this.maritimeAlerts.length

                this.totalEvent = this.alerts.length + this.avsecAlerts.length +  0
                setTimeout(() => this.handleNoDataAvailable(), 10)
            },
            hideAlertFlyout() {
                this.eventsDaysToDisplay = 1
                document.getElementsByClassName('app-template')[0].classList.remove('event-panel-show')
                if (SideNavigation?.$data) SideNavigation.$data.activeModule = ''
            },
            handleShowMoreClick() {
                this.eventsDaysToDisplay = this.eventsDaysToDisplay + 1
                setTimeout(() => this.handleNoDataAvailable(), 10)
            },
            handleNoDataAvailable() {
                document.querySelectorAll('.event-list__group').forEach(res => {
                    let data = res.querySelector('#events-list')
                    if (!data || data?.length === 0) {
                        res.querySelector('#not-available').style.display = 'block'
                    } else {
                        res.querySelector('#not-available').style.display = 'none'
                    }
                })
            },
            showFilters() {
                EventFilter.show()
            },
            addEvents() {
                User.getLocalUserSettings().then(userInfo => {
                    userInfo.airportsWatchlist.forEach(airportICAO => {
                        this.watchListAirports = this.airportsData.filter(airport => airport.ICAO === airportICAO)
                    })
                })

                let eventsToAdd = []

                this.alerts.forEach(alert => {
                    let alertDate = alert.CreatedDate !== '' ? alert.CreatedDate : alert.ActiveFrom
                    let coordinates = alert.Locations?.features?.[0]?.geometry?.coordinates || []
                    eventsToAdd.push({
                        id: alert.Id,
                        isInternationalSOSAlert: true,
                        date: moment.utc(alertDate).format(),
                        time: moment(alertDate).format('HH:mm'),
                        location: alert.TitleLocation,
                        description: alert.Title,
                        categories: alert.Categories,
                        status: alert.Status,
                        service: alert.Service,
                        coordinates: coordinates.length > 0 ? [coordinates[1], coordinates[0]] : null
                    })
                })

                this.maritimeAlerts?.forEach((alert) => {
                    const countryName = alert?.entity?.name ?? ''
                    const areaName = alert?.area?.name ?? ''
                    const regionName = alert?.region?.name ?? ''
                    const names = [regionName, areaName, countryName].filter(name => name !== '')
                    const location = names.join(', ')
                    eventsToAdd.push({
                        id: alert.id,
                        isMaritimeAlert: true,
                        date: moment.utc(alert.date).format(),
                        time: moment(alert.date).format('HH:mm'),
                        location: location,
                        description: alert.title,
                        summary: alert.description,
                        teaser: alert.teaser,
                        categories: [alert?.type?.description],
                        maritimeTypeId: alert.type.id
                    })
                })

                this.avsecAlerts.forEach(alert => {
                    eventsToAdd.push({
                        id: alert.NodeId,
                        isAvsecAlert: true,
                        date: moment.utc(alert.Date).format(),
                        time: moment(alert.Date).format('HH:mm'),
                        location: alert.SelectedCountry,
                        isoCode2: alert.CountriesAffected?.[0]?.CountryCodeAlpha2,
                        description: alert.Heading.replace(/(<([^>]+)>)/ig, ''),
                        longitude: alert.AffectedLocation?.latlng?.lng,
                        latitude: alert.AffectedLocation?.latlng?.lat,
                        isBreaking: alert.IsBreaking,
                        alertStatus: alert.AlertStatus,
                        AffectedAirports: alert.AffectedAirports,
                        CountriesAffected: alert.CountriesAffected,
                        categories: alert.Categories,
                        isAirportOnly: alert.isAirportOnly
                    })
                })

                let finalData = cloneDeep(eventsToAdd)
                // If active tab is MyAirports then we need to filter alerts by airport range.
                if (this.activeTab == 'MyAirports') {
                    finalData = finalData.map(event => {
                        if (!event.isMaritimeAlert && !event.isAvsecAlert && !event.isNewsAlert) {
                            let isAlertInsideAirportRange = checkIfAlertsAreInAirportRange(MyAirports.watchListAirports, event.coordinates, 40)
                            event.isAlertInsideAirportRange = isAlertInsideAirportRange
                        }
                        if (event.isAvsecAlert) {
                            let isAlertInsideAirportRange = MyAirports.watchListAirports.filter(element => event.AffectedAirports?.includes(element.ICAO))
                            event.isAlertInsideAirportRange = isAlertInsideAirportRange.length > 0 ? true : false
                        }
                        return event
                    })
                    finalData = finalData.filter(event => event.isAlertInsideAirportRange)
                } else {
                    finalData = eventsToAdd
                }

                // Sort events, newest are first in the array
                const sortedEventsByDate = sortBy(finalData, ['date']).reverse()
                this.eventsGroupedByDate = groupBy(sortedEventsByDate, event => {
                    return moment(event.date).startOf('day').format('DD MMM YYYY')
                })

                if (sortedEventsByDate[0]) {
                    const latestEvent = sortedEventsByDate[0]
                    const currentActiveComponent = AlertsBar !== null ? AlertsBar : AlertBarBottom 
                    if (latestEvent.isInternationalSOSAlert || latestEvent.isAvsecAlert) {
                        const headline = (latestEvent?.location && latestEvent?.description)
                            ? latestEvent?.location + ' | ' + latestEvent?.description
                            : latestEvent?.location || latestEvent?.description || ''

                        currentActiveComponent.lastLiveEventHeadline = headline
                    } else if (latestEvent.isMaritimeAlert) {
                        currentActiveComponent.lastLiveEventHeadline = latestEvent.description || latestEvent.teaser
                        currentActiveComponent.lastLiveMaritimeAlertTypeId = latestEvent.maritimeTypeId
                    } else {
                        currentActiveComponent.lastLiveEventHeadline = latestEvent.description
                    }

                    if (latestEvent.isInternationalSOSAlert) {
                        if (latestEvent.service === 'Security') {
                            currentActiveComponent.lastLiveEventType = 'security-alert'
                        } else if (latestEvent.service === 'Medical') {
                            currentActiveComponent.lastLiveEventType = 'medical-alert'
                        }
                    } else if (latestEvent.isAvsecAlert) {
                        currentActiveComponent.lastLiveAviationAlertStatus = latestEvent.alertStatus

                        if (latestEvent.isAirportOnly)  {
                            currentActiveComponent.lastLiveEventType = 'airport-only-alert'
                        } else if (latestEvent.isBreaking) {
                            currentActiveComponent.lastLiveEventType = 'breaking-alert'
                        } else {
                            currentActiveComponent.lastLiveEventType = 'aviation-alert'
                        }
                    } else if (latestEvent.isMaritimeAlert) { 
                        currentActiveComponent.lastLiveEventType = 'maritime-alert' 
                    } else if (latestEvent.isNewsAlert) {
                        currentActiveComponent.lastLiveEventType = 'news-alert'
                    }
                }
            },
            openEvent(event) {
                let eventDetails = null
                if (event.isInternationalSOSAlert) {
                    eventDetails = this.alerts.find(alert => {
                        return alert.Id === event.id
                    })

                    EventDetailsPanel.showInternationalSOSAlert(eventDetails)
                } else if (event.isAvsecAlert) {
                    const avsecEvent = this.avsecAlerts.filter(alert => {
                        return alert.NodeId === event.id
                    })

                    // If only one country is affected then we pass it's code to highlight it, otherwise it won't highlight multiple
                    // countries, probably will be nice to add support for it
                    if (avsecEvent[0].CountriesAffected.length === 1) {
                        EventDetailsPanel.showAviationCountryAlerts(avsecEvent, avsecEvent[0].CountriesAffected[0].CountryCodeAlpha2, true)
                    } else {
                        // TODO: looks like we need to handle different types of aviation alerts using EventDetailsPanel.showAviationAlert
                        EventDetailsPanel.showAviationCountryAlerts(avsecEvent)
                    }
                } else if (event.isMaritimeAlert) {
                    eventDetails = this.maritimeAlerts.find(alert => alert.id === event.id)
                    EventDetailsPanel.showMaritimeAlert(eventDetails)
                }
            },
            changeTab(tab) {
                this.eventsDaysToDisplay = 1
                this.activeTab = tab

                setTimeout(() => this.handleNoDataAvailable(), 10)
            }
        },
        watch: {
            'displayAlerts': function () {
                this.getCounts()
            },
            'displayMaritimeAlerts': function () {
                this.getCounts()
            },
            'activeTab': function () {
                this.addEvents()
            }
        },
        template: HTMLTemplate
    }

    const DOMElement = document.getElementById('vue-event-panel')
    if (DOMElement === null) {
        return null
    } else {
        return Vue.createApp(vueComponent).use({
            install: (app) => {
                app.directive('tooltip', {
                    beforeMount(el, binding) {
                        tippy(el, {
                            content: binding.value,
                            placement: 'bottom-start',
                            animation: 'shift-away',
                            allowHTML: true,
                            trigger: 'mouseenter click focus',
                            arrow: false,
                            followCursor: true,
                            plugins: [followCursor]
                        })
                    }
                })
            }
        }).mount(DOMElement)
    }
})()
